import React from 'react';
import {Dialog, DialogContent, DialogTitle, IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CategoryForm from 'src/pages/categories/CategoryForm';
import useCategories from 'src/hooks/useCategories';

export default function AddCategoryModal({open, onClose, onCategoryCreated}) {
	const {addCategory} = useCategories();

	const handleSuccess = (newCategory) => {
		// Add the new category to the global state
		addCategory(newCategory);
		// Call the callback to automatically select the new category
		if (onCategoryCreated) {
			onCategoryCreated(newCategory);
		}
		// Close the modal
		onClose();
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
				إضافة تصنيف جديد
				<IconButton onClick={onClose} size="small">
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<CategoryForm onSuccess={handleSuccess} />
			</DialogContent>
		</Dialog>
	);
}
